import { cResource } from "./resource";

//Mirrors resourceclosings field for field, with "closing" read as "reduction" throughout,
//plus an adjustment. adjustmenttype says how adjustmentamount is read:
//  NEWCAPACITY - adjustmentamount is the capacity for the period, higher or lower than now
//  REDUCEBY    - adjustmentamount comes off the capacity (concurrentUses), 0 up to all of it
export interface resourcereductions {
    id: string;
    resourceid: string;
    resourcereductionid: string;
    name: string;
    resourcetoreduce: cResource;
    adjustmentamount: number;
    adjustmenttype: string;
    disabled: boolean;
    venueid: string;
    startdate: string,
    enddate: string,
    publicmessage: string;
    venuemessage: string;
    reductionbasedonday: boolean;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
  }
  export class cResourcereductions implements resourcereductions {
    id: string;
    resourceid: string;
    resourcereductionid: string;
    name: string;
    resourcetoreduce: cResource;
    adjustmentamount: number;
    adjustmenttype: string;
    disabled: boolean;
    venueid: string;
    startdate: string;
    enddate: string;
    publicmessage: string;
    venuemessage: string;
    reductionbasedonday: boolean;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
  }
